export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const SortTypeValue = {
  [SortEnum.ASC]: 'เก่าไปใหม่',
  [SortEnum.DESC]: 'ใหม่ไปเก่า',
}
